import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useStoreCart } from "@/store/storeCart";
import { Badge } from "@/components/ui/badge";

const StoreCartIcon = () => {
  const count = useStoreCart((s) => s.lines.reduce((n, l) => n + l.quantity, 0));
  return (
    <Link
      to="/store/cart"
      aria-label={`Cart with ${count} item${count === 1 ? "" : "s"}`}
      className="relative inline-flex h-10 w-10 items-center justify-center rounded-full hover:bg-muted transition-colors"
    >
      <ShoppingBag className="h-5 w-5" />
      {count > 0 && (
        <Badge
          className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 text-[10px] flex items-center justify-center"
          variant="default"
        >
          {count > 99 ? "99+" : count}
        </Badge>
      )}
    </Link>
  );
};

export default StoreCartIcon;
